export const parseWidgetData = (widgets) => {
    let widgetData = {}
    let selectedOptionId = null
    let etaSelectionData = null
    widgets.forEach((widget) => {
        switch (widget.type) {
            case "address": {
                widgetData["addressSelection"] = parseAddressSelection(widget)
                break
            }
            case "eta_selection": {
                if (widget.data && widget.data.options.length > 1) {
                    widgetData["showShipmentOptions"] = parseShippmentOption(widget)
                } else {
                    etaSelectionData = parseETASelectionWidgetData(
                        widget.data.options[0],
                        widget.data.options[0].id
                    )
                }
                break
            }
            case "footnotes": {
                widgetData["footnotes"] = {
                    data: [
                        {
                            header: widget.data.header,
                            displayText: widget.data.display_text,
                        },
                    ],
                }
                break
            }
            case "care_plan_checkbox": {
                widgetData["carePlanUpsell"] = parseCarePlanUpsell(widget)
                break
            }
        }
    })
    if (widgetData.showShipmentOptions) {
        selectedOptionId = widgetData.showShipmentOptions.selectedOptionId
        if (selectedOptionId) {
            let deliveryTypeData = widgetData.showShipmentOptions.options.find(
                (option) => option.id === selectedOptionId
            )
            etaSelectionData = parseETASelectionWidgetData(deliveryTypeData, selectedOptionId)
        }
    } else {
        selectedOptionId = etaSelectionData.optionId
    }
    return { widgetData: widgetData, selectedOptionId: selectedOptionId, etaSelectionData: etaSelectionData }
}
export const parseETASelectionWidgetData = (data, optionId, deliverySpeedId = null, shipmentId = null) => {
    return {
        header: data.delivery.title,
        showCpUpsell: data.show_cp_upsell,
        showFootnotes: data.show_footnotes,
        optionId,
        shipments: data.delivery?.shipments.map((item) => {
            return {
                skuListLimit: item.sku_list_limit,
                shouldShowSku: item.should_show_sku,
                header: item.title,
                underlineCtaLabel:
                    item.skus.length > item.sku_list_limit && item.should_show_sku ? item.sub_title : "",
                id: item.id,
                skus: item.should_show_sku ? getSkuToShow(item.skus, item.sku_list_limit) : [],
                deliverySpeedOptions: item.delivery_speed?.options?.map((option) => {
                    return {
                        title: option.title,
                        subtitle: option.subtitle,
                        deliveryInfo: option.delivery_info,
                        discountedPriceValue: option.discounted_price_value,
                        id: option.id,
                        isSelected:
                            shipmentId === item.id && option.id === deliverySpeedId
                                ? true
                                : shipmentId !== item.id && shipmentId
                                ? option.selected
                                : shipmentId === item.id && option.id !== deliverySpeedId
                                ? false
                                : option.selected,

                        price: option.price || "",
                        discountedPrice: option.discounted_price || "",
                        carePlanInfo: {
                            isCarePlanAdded: option.care_plan_info?.is_care_plan_added,
                            isCarePlanUser: option.care_plan_info?.is_care_plan_user,
                            text: option.care_plan_info?.text,
                            subText: option.care_plan_info?.sub_text,
                            bgColor: option.care_plan_info?.bg_color,
                        },
                        functionMap: "OPEN_CARE_PLAN_UPSELL",
                    }
                }),
                hiddenSkus: getSkuToHide(item.skus, item.sku_list_limit),
            }
        }),
    }
}

const parseShippmentOption = (widget) => {
    return {
        header: widget.data.title,
        subHeader: widget.data.sub_title,
        options: widget.data.options.map((item) => {
            return {
                header: item.title,
                subHeader: item.subtitle,
                imageUrl: item.icon,
                id: item.id,
                delivery: item.delivery,
                showCpUpsell: item.show_cp_upsell,
                showFootnotes: item.show_footnotes,
            }
        }),
        selectedOptionId: widget.data.options.find((item) => item.opted)?.id ?? null,
    }
}

const parseAddressSelection = (widget) => {
    return {
        header: widget.data.header,
        addressName: widget.data.address_name,
        addressType: widget.data.address_type,
        address: `${widget.data.street1 ? widget.data.street1 + ", " : ""}${
            widget.data.street2 ? widget.data.street2 + ", " : ""
        }${
            widget.data.city && widget.data.street1
                ? decodeURI(widget.data.city) + ", "
                : decodeURI(widget.data.city)
        }${widget.data.locality ? widget.data.locality + ", " : ""}${widget.data.state}${
            widget.data.pincode ? " (" + widget.data.pincode + ")" : ""
        }`,
        ctaLabel: widget.data.cta?.text,
        ctaAction: widget.data.cta?.action,
        redirectUrl: widget.data.cta?.target_url,
        icon: widget.data.icon,
        geodataUpdateRequired: widget.data.is_geodata_update_required,
        id: widget.data.id,
    }
}

const parseCarePlanUpsell = (widget) => {
    return {
        header: widget.data.title,
        subHeader: widget.data.description,
        isSelected: widget.data.is_selected,
        icon: widget.data.icon,
        displayText: widget.data.offer_text,
        ctaLabel: widget.data.cta?.text,
        price: widget.data.prices.mrp,
        discountedPrice: widget.data.prices.discounted_price,
        discountPercent: widget.data.prices.discount,
    }
}

const getSkuToShow = (skuList, limit) => {
    return skuList
        ?.filter((item, index) => index < limit)
        .map((item) => {
            return {
                imageUrl: item.icon,
                header: item.title,
                subHeader: item.sub_title,
                quantity: item.quantity,
                subCategory: item.sub_category,
                skuId: item.sku_id,
            }
        })
}
const getSkuToHide = (skuList, limit) => {
    return skuList
        ?.filter((item, index) => index >= limit)
        .map((item) => {
            return {
                imageUrl: item.icon,
                header: item.title,
                subHeader: item.sub_title,
                quantity: item.quantity,
                subCategory: item.sub_category,
                skuId: item.sku_id,
            }
        })
}
export const parseSkuList = (skuList) => {
    let listOfItems = {
        groupItems: [
            {
                itemInCart: skuList.map((item) => {
                    return {
                        imageUrl: item.imageUrl,
                        header: item.header,
                        subHeader: item.subHeader,
                        skuId: item.skuId,
                        quantity: item.quantity,
                    }
                }),
            },
        ],
    }
    return listOfItems
}
export const parsePageInfoWidget = (pageInfoData) => {
    let pageInfoWidgets = {}
    if (pageInfoData.action_button) {
        pageInfoWidgets["actionButton"] = {
            action: pageInfoData.action_button.details?.target_url,
            targetUrl: pageInfoData.action_button.target_url,
            text: pageInfoData.action_button.text,
        }
    }
    if (pageInfoData.care_plan_upsell) {
        let data = pageInfoData?.care_plan_upsell
        pageInfoWidgets["carePlanDialogData"] = {
            header: data.header,
            imageUrl: data.icon,
            displayText: data.display_text,
            planDetails:
                data.plan_details && Object.keys(data.plan_details).length > 0
                    ? {
                          header: data.plan_details.header,
                          subHeader: data.plan_details.sub_header,
                          priceDetails: {
                              price: data.plan_details.prices?.mrp,
                              discount: data.plan_details.prices?.discount,
                              discountedPrice: data.plan_details.prices?.discounted_price,
                          },
                          cta: {
                              label: data.plan_details.cta?.text,
                              url: data.plan_details.cta?.details?.target_url,
                              functionMap: "carePlanInfoDialog",
                          },
                      }
                    : {},
            benefits: data.benefits?.map((benefit) => {
                return {
                    icon: benefit.icon,
                    displayText: benefit.display_text,
                }
            }),
            addToCart: {
                label: data.primary_cta?.text,
                payload: {
                    skus: [
                        {
                            quantity: data.primary_cta?.details?.quantity,
                            sku_id: data.primary_cta?.details?.sku_id,
                        },
                    ],
                    page_source: "shipment",
                },
                responseType: "brief",
            },
            secondaryCta: {
                label: data.secondary_cta?.text,
            },
            skuDetails: {
                quantity: data.primary_cta?.details?.quantity,
                skuId: data.primary_cta?.details?.sku_id,
            },
        }
    }
    return pageInfoWidgets
}
export const changeEtaSelectedItem = (data, deliverySpeedId = null, shipmentId = null) => {
    return {
        header: data.header,
        showCpUpsell: data.showCpUpsell,
        showFootnotes: data.showFootnotes,
        optionId: data.optionId,
        shipments: data.shipments?.map((item) => {
            return {
                skuListLimit: item.skuListLimit,
                shouldShowSku: item.shouldShowSku,
                header: item.header,
                underlineCtaLabel: item.underlineCtaLabel,
                id: item.id,
                skus: item.skus,
                deliverySpeedOptions: item.deliverySpeedOptions?.map((option) => {
                    return {
                        title: option.title,
                        subtitle: option.subtitle,
                        deliveryInfo: option.deliveryInfo,
                        discountedPriceValue: option.discountedPriceValue,
                        id: option.id,
                        isSelected:
                            shipmentId === item.id && option.id === deliverySpeedId
                                ? true
                                : shipmentId !== item.id && shipmentId
                                ? option.isSelected
                                : shipmentId === item.id && option.id !== deliverySpeedId
                                ? false
                                : option.isSelected,

                        price: option.price,
                        discountedPrice: option.discountedPrice,
                        carePlanInfo: option.carePlanInfo,
                        functionMap: option.functionMap,
                    }
                }),
                hiddenSkus: item.hiddenSkus,
            }
        }),
    }
}

export const parseCarePlanDialogData = (data) => {
    return {
        header: data.header,
        imageUrl: data.icon,
        displayText: data.display_text,
        planDetails:
            data.plan_details && Object.keys(data.plan_details).length > 0
                ? {
                      header: data.plan_details.header,
                      subHeader: data.plan_details.sub_header,
                      priceDetails: {
                          price: data.plan_details.prices?.mrp,
                          discount: data.plan_details.prices?.discount,
                          discountedPrice: data.plan_details.prices?.discounted_price,
                      },
                      cta: {
                          label: data.plan_details.cta?.text,
                          url: data.plan_details.cta?.details?.target_url,
                          functionMap: "carePlanInfoDialog",
                      },
                  }
                : {},
        benefits: data.benefits?.map((benefit) => {
            return {
                icon: benefit.icon,
                displayText: benefit.display_text,
            }
        }),
        addToCart: {
            label: data.primary_cta?.text,
            payload: {
                skus: [
                    {
                        quantity: data.primary_cta?.details?.quantity,
                        sku_id: data.primary_cta?.details?.sku_id,
                    },
                ],
                page_source: "order_summary",
            },
            responseType: "brief",
        },
        secondaryCta: {
            label: data.secondary_cta?.text,
        },
        skuDetails: {
            quantity: data.primary_cta?.details?.quantity,
            skuId: data.primary_cta?.details?.sku_id,
        },
    }
}
